<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">{{ $t('message.dashboard.title') }}</h1>
    <p class="mb-8 leading-normal">
      <!-- Hi <span class="text-indigo-400 font-semibold">{{ auth.user.first_name }}!</span> Welcome to Nafa Support Portal, a System designed to facilitate some of Nafa activities. -->
      {{ $t('message.dashboard.dashboard_welcome_message', { name: auth.user.first_name }) }}
    </p>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  props: {
    auth: Object,
  },
  layout: Layout,
}
</script>
